export default {
  Get: {
    PUBLISH_SMOOVED: 'getPublishSmooved',
  },
  Set: {
    SMOOVED_REQUEST_INFO: 'setSmoovedRequestInfo',
    SMOOVED_ASSIGN_VALUE: 'assignSmoovedValue',
    PRIMARY_CONTACT_ASSIGNVALUE: 'assignPrimaryContactValue',
    PRIMARY_CONTACT_RESET: 'resetPrimaryContactValue',
    SECONDARY_CONTACT_ASSIGNVALUE: 'assignSecondaryContactValue',
    SECONDART_CONTACT_RESET: 'resetSecondaryContactValue',
    LEAVING_CUSTOMER_ASSIGNVALUE: 'assignLeavingCustomerValue',
    LEAVING_CUSTOMER_RESET: 'resetLeavingCustomer',
    CONNECTION_ASSIGNVALUE: 'assignConnectionValue',
    CONNECTION_RESET: 'resetConnectionValue'
  }
};